/**
 *
 * Styles for EstimatedDeliveryInfo
 *
 */

import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { TYPES_OF_OFFERS } from "one-time-shipment/src/containers/GetQuote/constants";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const DeliveryTimeText = styled(DhlText)`
  & > *:is(p, span) {
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: var(--dui-color-black-500) !important;
  }
  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-top: 0;
    padding-left: ${({ variation }) =>
      variation === TYPES_OF_OFFERS.WCC ? "" : "var(--gaq-size-space-7px)"};
    margin-left: ${({ variation }) =>
      variation === TYPES_OF_OFFERS.WCC ? "" : "var(--gaq-size-space-7px)"};
    border-left: var(--dui-size-width-border-sm) solid var(--dui-color-gray-300);
  }
`;

export const DeliveryDateHeadline = styled(DhlText)`
  & > *:is(p, span) {
    color: var(--dui-color-black-500) !important;
    font-size: 2rem;
    line-height: 2.4rem;
    margin: 0;
    font-weight: 800;
    white-space: normal;

    @media screen and (min-width: ${breakpoints.tablet}) {
      white-space: nowrap;
    }
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    max-width: 33.5rem;
  }
`;

export const DateTimeWrapper = styled.div`
  display: flex;
  flex-direction: column;

  > p {
    white-space: nowrap;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    line-height: 24px;
    display: flex;
    margin-top: var(--gaq-size-space-5px);
    margin-bottom: var(--dui-size-space-4x);
    justify-content: flex-start;
    align-items: ${({ variation }) =>
      variation === TYPES_OF_OFFERS.WCC ? "start" : "center"};
    flex-direction: ${({ variation }) =>
      variation === TYPES_OF_OFFERS.WCC ? "column" : "row"};
    flex-wrap: nowrap;
  }

  &.wrap-mobile {
    margin: 0;

    ${DeliveryTimeText} {
      @media screen and (min-width: ${breakpoints.desktop}) {
        border-left: var(--dui-size-width-border-xs) solid
          var(--dui-color-black-500);
        font-size: 1.6rem;
        font-weight: 400;
        line-height: 1.6rem;
      }
    }

    ${DeliveryDateHeadline} {
      @media screen and (min-width: ${breakpoints.desktop}) {
        font-weight: 200;
        font-size: 1.6rem;
        font-weight: 400;
        line-height: 1.6rem;
      }
    }
  }
`;
